import { Pill } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import type { ChannexRevisionHoldList } from '@/shared/api';

interface Props {
  list: ChannexRevisionHoldList;
  /** Eingebettet trägt die Karte ihren Titel selbst; auf der eigenen Seite der Seitenkopf. */
  embedded: boolean;
}

/**
 * Zahlen und Erklärung über der Liste. Die Zahlen kommen vom Server und zählen alle sichtbaren
 * Kanalbuchungen ohne Buchung, nicht nur die mitgelieferten Zeilen.
 */
export function RevisionHoldsIntro({ list, embedded }: Props) {
  const { t } = useTranslation('revisionHolds');
  return (
    <>
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        {embedded && (
          <h2 className="text-ink font-serif text-lg">Nicht zugeordnete Kanalbuchungen</h2>
        )}
        <div className="flex flex-wrap gap-1.5">
          {list.quarantinedTotal > 0 && (
            <Pill variant="stop" size="sm">{`${list.quarantinedTotal} in Quarantäne`}</Pill>
          )}
          {list.awaitingTotal > 0 && (
            <Pill variant="warning" size="sm">{`${list.awaitingTotal} wartend`}</Pill>
          )}
        </div>
      </div>
      <p className="text-ink-soft mt-2 text-sm">{t('intro')}</p>
      <p className="text-ink-soft mt-2 text-sm">{t('availabilitySeparate')}</p>
    </>
  );
}

/** Wie viele sichtbare Kanalbuchungen die Liste nicht mitgeliefert hat. */
export function MoreHolds({ list }: { list: ChannexRevisionHoldList }) {
  const more = list.quarantinedTotal + list.awaitingTotal - list.items.length;
  if (more <= 0) return null;
  return (
    <p className="text-ink-soft mt-3 text-sm">
      {more === 1
        ? 'Eine weitere Kanalbuchung ist hier nicht aufgeführt'
        : `Weitere ${more} Kanalbuchungen sind hier nicht aufgeführt`}
      {` — die Liste zeigt die ersten ${list.items.length}, Quarantäne zuerst.`}
    </p>
  );
}
